export default __webpack_public_path__ + "static/media/livro6.371b3668.png";